import type { ProfilePlanModel } from "@payping/api";
import { dateFormats, toJalali } from "@payping/utils/dateUtils";
import { FC, ReactElement } from "react";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { useAppSelector } from "@/utils/redux";

interface Props {
  plan: ProfilePlanModel;
}

export const PlanButtonSub: FC<Props> = (props) => {
  const { plan } = props;
  const { t } = useAppTranslation();
  const currentPlan = useAppSelector((state) => state.user?.panelInfo?.currentPlan);
  const planExpireDate = useAppSelector((state) => state.user?.panelInfo?.planExpireDate);
  const pendingPlanId = useAppSelector((state) => state.user?.panelInfo?.pendingPlan?.id);

  let buttonSub: ReactElement = <></>;

  if (currentPlan?.id === plan.id && !plan.isDefaultPlan) {
    buttonSub = (
      <span className="color--gray500">
        {`${t("expireDate")}: `}
        {
          toJalali({
            date: planExpireDate,
            dateFormat: dateFormats.standard.utcDateTime,
            toFormat: "jDD jMMM jYYYY",
          }).string
        }
      </span>
    );
  } else if (pendingPlanId === plan.id) {
    buttonSub = <>{t("upgrade.pendingMessage")}</>;
  } else if (plan.trialDays && plan.trialDays > 0)
    buttonSub = <>{t("upgrade.freeCommission", { days: plan.trialDays })}</>;

  return buttonSub;
};
